import { FETCH_USER_DATA_FULFILLED } from './actions';

import type { User } from '@/types/user';

export interface UserAction {
  type: string;
  payload?: User;
}

export const initialState: User = {
  _id: '',
  uuid: '',
  organizationId: '',
  roles: [],
  productIds: [],
  email: '',
  activated: false,
  createdByEmail: '',
  businessUnitIds: [],
  idm: '',
  organization: {
    _id: '',
    enterpriseName: '',
    productIds: [],
    businessUnitIds: [],
    marketplaceItemIds: [],
    schemaVersion: 1,
    createdAt: '',
    updatedAt: '',
    type: '',
    __v: 0,
  },
  role: '' as unknown as User['role'],
  beautifiedRole: '',
};

const beautifyRole = (role: string): string =>
  role
    .toLowerCase()
    .split('_')
    .map((el: string) => (el ? (el[0]?.toUpperCase() ?? '') + el.substring(1) : ''))
    .join(' ');

const userReducer = (state: User = initialState, action: UserAction): User => {
  if (action.type === FETCH_USER_DATA_FULFILLED) {
    return {
      ...state,
      ...action.payload,
      beautifiedRole: beautifyRole(action.payload?.roles?.[0] ?? ''),
    };
  } else {
    return state;
  }
};

export { userReducer };
